import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=42f64cce&scoped=true&"
var script = {}
import style0 from "./agreement.vue?vue&type=style&index=0&id=42f64cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f64cce",
  null
  
)

export default component.exports